<div class="root">
    <ngx-masonry #masonry [options]="{ gutter: 20, animations: {} }">
        <puff ngxMasonryItem *ngFor="let item of startPageSections$ | async" [heading]="item.heading" [text]="item.shortCopy" [url]="item.url"
              class="root__item">
        </puff>
    </ngx-masonry>
</div>
